import * as React from 'react';

export default class Decendings extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} viewBox="0 0 16 16" xmlnsXlink="http://www.w3.org/1999/xlink" onClick={this.props.onClick}>
        <path stroke="#020303" strokeLinecap="round" strokeLinejoin="round" d="M6.728 12.693V2.2L3.5 5.407"/>
        <path stroke="#43ADF1" strokeLinecap="round" strokeLinejoin="round" d="M9.5 4.187V14.68l3.228-3.208"/>
      </svg>
    )
  }
}
